const GLOSSARY = '';
module.exports = { GLOSSARY };